export default __webpack_public_path__ + "static/img_bubbles_onetokens-45751785e42c924c9092969cf25c3e5c.svg";